import * as React from 'react';
import { getFormatDateFromStoreDate } from 'shared-components';
import { Section } from '../../../../Finger/Section';
import { getFingerStatus, getVisible, hasDeleted } from '../../../../../utilities/documents';
import FingerWithApprove from '../../../../atoms/finger-with-approve';
import NoDocuments from '../../../../atoms/no-doc-placeholder';

import { UserRole } from '../../../../../store/auth/types';
import { SummaryRow } from '../../../../Summary/SummaryRow';
import { DocAccessType, IFollowUpDocuments, VisaApplicationPdfCopyDocList } from '../../../../../types';

interface IProps {
  userAccess?: DocAccessType;
  documents: IFollowUpDocuments['beforeTravel']['visaApplicationPdfCopy'];
  userRole?: UserRole;

  canResume: boolean;
  canUpload: boolean;
  canOpen: boolean;
  canApprove: boolean;
  canReject: boolean;
  isDeleting: boolean;

  onUploadClick: (docKey: string) => void;
  onOpenClick: (docKey: string) => void;
  onApproveClick: (docKey: string) => void;
  onRejectClick: (docKey: string) => void;
  onRescindRejectClick: (docKey: string) => void;
  onDeleteClick: (docKey: string) => void;
  onAcknowledgeClick: (docKey: string) => void;
}
const VisaApplicationPdfCopy = (props: IProps) => {
  const { documents: visaApplicationPdfCopyDocs, userAccess, userRole } = props;

  const visibleDocs = getVisible({ documentsHash: visaApplicationPdfCopyDocs, userAccess, userRole });

  const hasDocs = visibleDocs.length > 0;
  const hasDeletedDocs = hasDeleted(visaApplicationPdfCopyDocs);

  const docNodes: React.ReactNode[] = [];

  if (!hasDocs && !hasDeletedDocs) {
    return null;
  }

  if (userAccess && !hasDocs) {
    return null;
  }

  if (hasDocs) {
    docNodes.push(
      ...visibleDocs.map(
        (visaApplicationPdfCopy: VisaApplicationPdfCopyDocList, visaApplicationPdfCopyIndex: number) => {
          const { key: docKey, item } = visaApplicationPdfCopy;

          return (
            <FingerWithApprove
              id={`visa-application-pdf-copy-${docKey}`}
              key={`visa-application-pdf-copy-${docKey}`}
              status={getFingerStatus(item)}
              isProcessingPdf={item.isProcessingPdf}
              reason={item.reason}
              fileCount={item.signedUrls && item.signedUrls.length > 0 ? item.signedUrls.length : 0}
              fileNames={item.fileNames}
              label={`Visa Application PDF Copy ${
                Object.keys(visaApplicationPdfCopy ?? {}).length > 1
                  ? visaApplicationPdfCopyIndex > 0
                    ? visaApplicationPdfCopyIndex + 1
                    : ''
                  : ''
              }`}
              canUpload={props.canUpload}
              canOpen={props.canOpen}
              canApprove={props.canApprove}
              canReject={props.canReject}
              isDeleting={props.isDeleting}
              canAcknowledge={false}
              onUploadClick={() => {
                props.onUploadClick(docKey);
              }}
              onOpenClick={() => {
                props.onOpenClick(docKey);
              }}
              onApproveClick={() => {
                props.onApproveClick(docKey);
              }}
              onRejectClick={() => {
                props.onRejectClick(docKey);
              }}
              onRescindRejectClick={() => {
                props.onRescindRejectClick(docKey);
              }}
              onDeleteClick={() => {
                props.onDeleteClick(docKey);
              }}
              onAcknowledgeClick={() => {}}
              userRole={props.userRole}
              deletedByTTL={item.deletedByTTL}
            >
              <SummaryRow
                key={`visa-application-pdf-copy-date-${docKey}`}
                label="Application date"
                fullLabel="What date did you submit this application?"
                value={getFormatDateFromStoreDate(item.date)}
              />
            </FingerWithApprove>
          );
        },
      ),
    );
  }

  return (
    <>
      <Section
        key={`before-travel`}
        label={'Copy of visa application sent by email after visa submission'}
        canEdit={false}
        warning={''}
      >
        {hasDocs ? docNodes : <NoDocuments />}
      </Section>
    </>
  );
};

export default VisaApplicationPdfCopy;
